<script>
import SendSupportRequestButton from '@/components/support-requests/send-support-request-button.vue'
import SendSupportRequestModal from '@/components/support-requests/send-support-request-modal.vue'
import TaxReceiptsRequestPublicModal from './home/tax-receipts-request-public-modal.vue'
import TwButton from './generic/tw-button.vue'
import OrganizationRegisterChatModal from './organizations/organization-register-chat-modal.vue'

export default {
  name: 'GrouprevPublicFooter',
  components: { OrganizationRegisterChatModal, TwButton, TaxReceiptsRequestPublicModal, SendSupportRequestModal, SendSupportRequestButton }
}
</script>

<template>
  <div class="text-center flex flex-wrap justify-center gap-6 text-gray-600 text-xs my-8">
    <router-link :to="{ name: 'Home' }">
      Home
    </router-link>
    <router-link :to="{ name: 'StaticTermsOfUsePage' }">
      Terms of Use
    </router-link>
    <router-link :to="{ name: 'StaticPrivacyPolicyPage' }">
      Privacy Policy
    </router-link>
    <router-link :to="{ name: 'StaticDisclaimerPage' }">
      Disclaimer
    </router-link>
    <send-support-request-button class="hover:text-gray-900" @open-modal="$refs.publicSupportModal.open()">
      Request Support
    </send-support-request-button>
    <tw-button variant="link" size="xs" @click="$refs.taxReceiptsRequestPublicModal.open()">
      Request Tax Receipts
    </tw-button>
    <tw-button variant="link" size="xs" @click="$refs.organizationRegisterChatModal.open()">
      Wizard Sign Up
    </tw-button>
    <tax-receipts-request-public-modal ref="taxReceiptsRequestPublicModal" />
    <send-support-request-modal ref="publicSupportModal" />
    <organization-register-chat-modal ref="organizationRegisterChatModal" />
  </div>
</template>

<style scoped>

</style>
